const TIMESHEETS_REPORT_VIEWED = 'Report Viewed';
const TIMESHEETS_FILTER_SET = 'Filter Set';
const TIMESHEETS_TABLE_COLUMNS_SET = 'Table Columns Set';
const TIMESHEETS_EVENTS = 'Events';
const TIMESHEETS_GRAPH_TYPE_SET = 'Graph Type Set';
const TIMESHEETS_LOCATION_HISTORY_FILTER_TYPE_SET = 'Location History Filter Type Set';
const TIMESHEET_SUMMARY_EXPORT = 'Timecards Summary Exported';
const TIMESHEETS_BASIC_EXPORT = 'Timecards Basic Exported';
const TIMESHEETS_EXPANDED_EXPORT = 'Timecards Expanded Exported';
const TIMESHEETS_ENTRIES_EXPORT = 'Timecards Entries Exported';
const TIMESHEETS_WEEKLY_GRID_EXPORT = 'Timecards Weekly Grid Exported';
const TIMESHEETS_SUMMARY_PRINT = "Timecards Summary Printed";
const TIMESHEETS_BASIC_PRINT = "Timecards Basic Printed";
const TIMESHEETS_EXPANDED_PRINT = "Timecards Expanded Printed";
const TIMESHEETS_ENTRIES_PRINT = "Timecards Enrties Printed";
const TIMESHEETS_WEEKLY_GRID_PRINT = "Timecards Weekly Grid Printed";

const timesheetsAnalyticsConstants = {
  TIMESHEETS_REPORT_VIEWED,
  TIMESHEETS_FILTER_SET,
  TIMESHEETS_TABLE_COLUMNS_SET,
  TIMESHEETS_EVENTS,
  TIMESHEETS_GRAPH_TYPE_SET,
  TIMESHEETS_LOCATION_HISTORY_FILTER_TYPE_SET,
  TIMESHEET_SUMMARY_EXPORT,
  TIMESHEETS_BASIC_EXPORT,
  TIMESHEETS_EXPANDED_EXPORT,
  TIMESHEETS_ENTRIES_EXPORT,
  TIMESHEETS_WEEKLY_GRID_EXPORT,
  TIMESHEETS_SUMMARY_PRINT,
  TIMESHEETS_BASIC_PRINT,
  TIMESHEETS_EXPANDED_PRINT,
  TIMESHEETS_ENTRIES_PRINT,
  TIMESHEETS_WEEKLY_GRID_PRINT,
};

export default timesheetsAnalyticsConstants;
